import * as yup from "yup";

const draftFileSchema = yup.object({
  name: yup.string().required(),
  type: yup.string().required(),
  uri: yup.string().required(),
  externalId: yup.string().required(),
  _id: yup.string().required(),
});

export default draftFileSchema;
